import { render } from "./ResourceModalMolecule.vue?vue&type=template&id=2baab116&scoped=true"
const script = {}

import "./ResourceModalMolecule.vue?vue&type=style&index=0&id=2baab116&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baab116"]])

export default __exports__